/* Hallows Night — comportamiento compartido. Sin librerías. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Un único tipo de animación de entrada ---------- */
  function initReveal(root) {
    var items = (root || document).querySelectorAll('.hn-reveal:not(.is-in)');
    if (!items.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.classList.add('is-in');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -6% 0px', threshold: 0.05 }
    );

    items.forEach(function (el) {
      io.observe(el);
    });

    /* Red de seguridad. El observador no dispara mientras la pestaña está en
       segundo plano, así que si alguien abre la tienda en una pestaña de fondo
       y luego va a ella, el contenido podría quedarse invisible. Aquí se
       revela a mano todo lo que ya esté a la vista, sin esperar al observador. */
    function rescatarVisibles() {
      var alto = window.innerHeight || document.documentElement.clientHeight;
      items.forEach(function (el) {
        if (el.classList.contains('is-in')) return;
        if (el.getBoundingClientRect().top < alto) {
          el.classList.add('is-in');
          io.unobserve(el);
        }
      });
    }

    window.setTimeout(rescatarVisibles, 1500);

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) window.setTimeout(rescatarVisibles, 120);
    });
  }

  /* ---------- Acordeón accesible (FAQ, envíos) ---------- */
  function initAccordion(root) {
    var groups = (root || document).querySelectorAll('[data-hn-accordion]');
    groups.forEach(function (group) {
      if (group.hnBound) return;
      group.hnBound = true;

      group.addEventListener('click', function (event) {
        var btn = event.target.closest('.hn-acc__trigger');
        if (!btn || !group.contains(btn)) return;

        var item = btn.closest('.hn-acc__item');
        var panel = item.querySelector('.hn-acc__panel');
        var open = btn.getAttribute('aria-expanded') === 'true';

        if (group.getAttribute('data-hn-accordion') === 'single' && !open) {
          group.querySelectorAll('.hn-acc__trigger[aria-expanded="true"]').forEach(function (other) {
            other.setAttribute('aria-expanded', 'false');
            var op = other.closest('.hn-acc__item').querySelector('.hn-acc__panel');
            op.style.maxHeight = '0px';
            op.setAttribute('hidden', '');
          });
        }

        if (open) {
          btn.setAttribute('aria-expanded', 'false');
          panel.style.maxHeight = '0px';
          window.setTimeout(function () {
            if (btn.getAttribute('aria-expanded') === 'false') panel.setAttribute('hidden', '');
          }, 240);
        } else {
          btn.setAttribute('aria-expanded', 'true');
          panel.removeAttribute('hidden');
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });

      window.addEventListener('resize', function () {
        group.querySelectorAll('.hn-acc__trigger[aria-expanded="true"]').forEach(function (btn) {
          var panel = btn.closest('.hn-acc__item').querySelector('.hn-acc__panel');
          panel.style.maxHeight = panel.scrollHeight + 'px';
        });
      });
    });
  }

  /* ---------- Descripción de producto → apartados desplegables ----------
     La descripción viene con <h3> por apartado. El primero queda abierto
     (qué hace el producto); el resto se pliega. Sin JS se ve todo, tal cual. */
  function initDescription(root) {
    var descs = (root || document).querySelectorAll('.product__description:not([data-hn-ready])');
    descs.forEach(function (desc) {
      var heads = desc.querySelectorAll('h3');
      if (heads.length < 2) return;
      desc.setAttribute('data-hn-ready', '');

      var wrap = document.createElement('div');
      wrap.className = 'hn-desc';

      heads.forEach(function (h3, index) {
        var item = document.createElement('div');
        item.className = 'hn-desc__item';

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'hn-desc__btn';
        btn.setAttribute('aria-expanded', index === 0 ? 'true' : 'false');
        var id = 'hn-desc-' + index + '-' + Math.random().toString(36).slice(2, 7);
        btn.setAttribute('aria-controls', id);
        btn.innerHTML =
          '<span>' +
          h3.textContent +
          '</span><span class="hn-desc__mark" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M12 5.5v13M5.5 12h13"/></svg></span>';

        var panel = document.createElement('div');
        panel.className = 'hn-desc__panel';
        panel.id = id;
        var inner = document.createElement('div');
        inner.className = 'hn-desc__panel-inner';

        // Mueve al panel todo lo que sigue al h3 hasta el próximo h3
        var node = h3.nextSibling;
        while (node && !(node.nodeType === 1 && node.tagName === 'H3')) {
          var next = node.nextSibling;
          inner.appendChild(node);
          node = next;
        }
        panel.appendChild(inner);

        if (index === 0) {
          panel.style.maxHeight = 'none';
        } else {
          panel.setAttribute('hidden', '');
        }

        item.appendChild(btn);
        item.appendChild(panel);
        wrap.appendChild(item);
        h3.remove();
      });

      desc.appendChild(wrap);

      wrap.addEventListener('click', function (event) {
        var btn = event.target.closest('.hn-desc__btn');
        if (!btn) return;
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        var open = btn.getAttribute('aria-expanded') === 'true';
        if (open) {
          panel.style.maxHeight = panel.scrollHeight + 'px';
          requestAnimationFrame(function () {
            panel.style.maxHeight = '0px';
          });
          btn.setAttribute('aria-expanded', 'false');
          window.setTimeout(function () {
            if (btn.getAttribute('aria-expanded') === 'false') panel.setAttribute('hidden', '');
          }, 240);
        } else {
          btn.setAttribute('aria-expanded', 'true');
          panel.removeAttribute('hidden');
          panel.style.maxHeight = panel.scrollHeight + 'px';
          window.setTimeout(function () {
            if (btn.getAttribute('aria-expanded') === 'true') panel.style.maxHeight = 'none';
          }, 260);
        }
      });
    });
  }

  /* ---------- Arranque ---------- */
  function initAll(root) {
    initReveal(root);
    initAccordion(root);
    initDescription(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:section:select', function (event) {
    initAll(event.target);
  });
})();
